module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_txt02-11dc06acddbd3c828989bad17d4a279f.svg";